import { DataSource, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommExAppControlTable extends Layout {
    sourceMCExApp: DataSource;
    tableGroupByVendor: Table;
    textboxGroupBy: Textbox;
}
